import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 6.58594V23H3V1H15.4141L21 6.58594ZM4 12V14H5.5V20H7.5V14H9V12H4ZM9.5 12V13.9082C9.5 14.2125 9.60127 14.4951 9.76758 14.7236C9.80787 14.779 9.84754 14.8253 9.86328 14.8438C9.88625 14.8707 9.8821 14.8661 9.87695 14.8594L10.7432 16L9.87695 17.1406C9.88209 17.1339 9.88628 17.1293 9.86328 17.1562L9.76758 17.2764C9.60123 17.5049 9.5 17.7875 9.5 18.0918V20H11.5V18.3086L12 17.6514L12.5 18.3086V20H14.5V18.0918C14.5 17.8255 14.4228 17.5756 14.292 17.3643L14.2324 17.2764L14.1367 17.1562C14.1138 17.1294 14.1179 17.1339 14.123 17.1406L13.2559 16L14.123 14.8594C14.1179 14.8661 14.1136 14.8708 14.1367 14.8438C14.1525 14.8253 14.1921 14.779 14.2324 14.7236C14.3987 14.4951 14.5 14.2125 14.5 13.9082V12H12.5V13.6904L12 14.3477L11.5 13.6904V12H9.5ZM15 12V14H16.5V20H18.5V14H20V12H15ZM14.5 7.5H19L14.5 3V7.5Z"}}]};

const FileTxtFilled = Vue.extend<IconProps>({
  name: 'FileTxtFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'file-txt-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FileTxtFilled;
